import { DocumentNode, gql } from '@apollo/client'

export const CREATE_API_CLIENT: DocumentNode = gql`
    mutation CreateApiClient(
        $email: String!
        $name: String!
        $daycareIds: [Int]
        $rateLimitPerMinute: Int
        $tokenExpiryMinutes: Int
    ) {
        createApiClient(
            email: $email
            name: $name
            daycareIds: $daycareIds
            rateLimitPerMinute: $rateLimitPerMinute
            tokenExpiryMinutes: $tokenExpiryMinutes
        )
    }
`

export const UPDATE_API_CLIENT: DocumentNode = gql`
    mutation UpdateApiClient($id: Int!, $input: UpdateApiClientInput!) {
        updateApiClient(id: $id, input: $input)
    }
`

export const DELETE_API_CLIENT: DocumentNode = gql`
    mutation DeleteApiClient($id: Int!) {
        deleteApiClient(id: $id)
    }
`
